const toDate = (date: Date | string): Date => (date instanceof Date ? date : new Date(date));

export const normalizeToLocalNoon = (date: Date): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0);

/** `yyyy-MM-dd`, the value format an `<input type="date">` expects. */
export const formatDateInputValue = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const dayOfMonth = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${dayOfMonth}`;
};

export const formatDate = (date: Date | string | null): string => {
  if (!date) return 'N/A';
  return toDate(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const formatDayOfYear = (date: Date | string): string =>
  toDate(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
